// 由 scripts/build-routes.ts 產生，不要手改。重跑：bunx tsx scripts/build-routes.ts
// 來源：docs/legacy-candidates.json（Gate 1 盤點候選，全部為「候選-未驗證」）

export type PageType = 'crud-list' | 'display' | 'report' | 'complex-form' | 'login' | 'redirect' | 'unresolved';

export interface RouteEntry {
  /** 盤點的 Page ID，也是 data-ui-id 的前綴來源（§10.1）。 */
  pageId: string;
  path: string;
  module: string;
  moduleLabel: string;
  title: string;
  pageType: PageType;
  /** 原系統 URL；null 代表沒有對應的 Spring endpoint。 */
  legacyUrl: string | null;
  classification: string;
  /** 只有 redirect-behavior 類有值（§5.2）。 */
  redirectTarget: string | null;
  /** FC-5：三角色可達性（legacy-visible.generated.ts）。找不到對應 legacy 頁時為 null。 */
  visibleTo: Readonly<Record<'admin' | 'teacher' | 'student' | 'mentor', 'reachable' | 'forbidden' | 'error' | 'redirect'>> | null;
}

export const routes: readonly RouteEntry[] = [
  {
    "pageId": "announcement-announcement-list",
    "path": "/announcement",
    "module": "announcement",
    "moduleLabel": "公告",
    "title": "公告",
    "pageType": "crud-list",
    "legacyUrl": "/announcement",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-account-v-2",
    "path": "/config/accountV2",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "帳號維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/accountV2",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-annual",
    "path": "/config/annual",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "年度維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/annual",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-comment",
    "path": "/config/comment",
    "module": "profile",
    "moduleLabel": "個人資料管理",
    "title": "常用語管理",
    "pageType": "crud-list",
    "legacyUrl": "/config/comment",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-department",
    "path": "/config/department",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "部門維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/department",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-device",
    "path": "/config/device",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "設備維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/device",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-forbid-word",
    "path": "/config/forbidWord",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "禁用語維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/forbidWord",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-job-title",
    "path": "/config/jobTitle",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "職稱維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/jobTitle",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-job-type",
    "path": "/config/jobTypeMaintain",
    "module": "job-type-config",
    "moduleLabel": "訓練類別管理",
    "title": "訓練類別設定",
    "pageType": "display",
    "legacyUrl": "/config/jobTypeMaintain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-job-type-department",
    "path": "/config/jobTypeDepartment",
    "module": "job-type-config",
    "moduleLabel": "訓練類別管理",
    "title": "訓練類別部門維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/jobTypeDepartment",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-location",
    "path": "/config/location",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "地點維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/location",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-organization",
    "path": "/config/organization",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "組織維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/organization",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "config-role",
    "path": "/config/role",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "角色及權限維護",
    "pageType": "crud-list",
    "legacyUrl": "/config/role",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "course-clazz-list",
    "path": "/course/clazz/class",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "開課管理",
    "pageType": "crud-list",
    "legacyUrl": "/course/clazz/class",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "course-clazz-query-list",
    "path": "/tsghfunc/homepageClassQuery",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "course-clazz-query-list",
    "pageType": "crud-list",
    "legacyUrl": "/tsghfunc/homepageClassQuery",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "course-clazz-query-list-class-query",
    "path": "/course/classQuery",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "課程查詢",
    "pageType": "crud-list",
    "legacyUrl": "/course/classQuery",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "course-course-manage",
    "path": "/course/courseManage",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "課程樣版維護",
    "pageType": "crud-list",
    "legacyUrl": "/course/courseManage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "course-course-static-list",
    "path": "/course/queryCourseStatic",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "開課統計",
    "pageType": "display",
    "legacyUrl": "/course/queryCourseStatic",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "course-course-type",
    "path": "/course/courseType",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "課程類別維護",
    "pageType": "crud-list",
    "legacyUrl": "/course/courseType",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-case-report",
    "path": "/customer/tsgh/caseReport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "案例報告統計",
    "pageType": "report",
    "legacyUrl": "/customer/tsgh/caseReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-cert-template-cfg",
    "path": "/customer/tsgh/certTemplateCfg",
    "module": "config",
    "moduleLabel": "系統資料管理",
    "title": "實習證明單樣板維護",
    "pageType": "display",
    "legacyUrl": "/customer/tsgh/certTemplateCfg",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-clert-cerk",
    "path": "/tsghfunc/toClerkCertPage",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "實習證明書",
    "pageType": "display",
    "legacyUrl": "/tsghfunc/toClerkCertPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-core-curriculum-report",
    "path": "/customer/tsgh/coreCurriculumReport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "核心課程查詢",
    "pageType": "report",
    "legacyUrl": "/customer/tsgh/coreCurriculumReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-course-record-report",
    "path": "/customer/tsgh/courseRecordReport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "修課紀錄查詢",
    "pageType": "report",
    "legacyUrl": "/customer/tsgh/courseRecordReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-high-risk-doctor-report",
    "path": "/tsghfunc/highRiskDoctorReport",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師高風險或高技術之醫療行為評核通過醫師名單",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/highRiskDoctorReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-high-risk-report",
    "path": "/tsghfunc/highRiskReport",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師高風險或高技術之醫療行為評核數量統計報表",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/highRiskReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-high-risk-setting",
    "path": "/tsghfunc/toHighRiskSetting",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師高風險及高技術項目設定",
    "pageType": "display",
    "legacyUrl": "/tsghfunc/toHighRiskSetting",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-high-risk-setting-report",
    "path": "/tsghfunc/toHighRiskSetReport",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師高風險及高技術項目設定結果報表",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toHighRiskSetReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-service-standard-cfg-report",
    "path": "/tsghfunc/serviceStandardCfgReport",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師合理醫療服務量設定結果報表",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/serviceStandardCfgReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-service-standard-report",
    "path": "/tsghfunc/serviceStandardReport",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師合理醫療服務量統計表",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/serviceStandardReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-service-standard-setting",
    "path": "/tsghfunc/toServiceStandardSetting",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師合理醫療服務量設定",
    "pageType": "display",
    "legacyUrl": "/tsghfunc/toServiceStandardSetting",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-tch-satisfaction-survey-report",
    "path": "/tsghrpt/tchSatisfactionSurveyReport/index",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "教師滿意度調查暨優良教師推薦",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/tchSatisfactionSurveyReport/index",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-to-high-risk-form",
    "path": "/tsghfunc/toHighRiskFormList",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師高風險及高技術之醫療行為評核",
    "pageType": "complex-form",
    "legacyUrl": "/tsghfunc/toHighRiskFormList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-to-service-standard-form",
    "path": "/tsghfunc/toServiceStandardFormList",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "主治醫師合理醫療服務量評估",
    "pageType": "complex-form",
    "legacyUrl": "/tsghfunc/toServiceStandardFormList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-tsgh-student-course-report",
    "path": "/customer/tsgh/studentCourseReport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "customer-tsgh-tsgh-student-course-report",
    "pageType": "report",
    "legacyUrl": "/customer/tsgh/studentCourseReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "customer-tsgh-tsgh-study-history-data",
    "path": "/prompt/customer/tsgh/downloadStudyHistory",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "customer-tsgh-tsgh-study-history-data",
    "pageType": "complex-form",
    "legacyUrl": "/prompt/customer/tsgh/downloadStudyHistory",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "customer-tsgh-tsgh-study-history-list",
    "path": "/customer/tsgh/studyHistoryList",
    "module": "study-passport",
    "moduleLabel": "學習歷程下載",
    "title": "學習歷程下載",
    "pageType": "display",
    "legacyUrl": "/customer/tsgh/studyHistoryList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "discuss-discuss-board",
    "path": "/discuss/discussBoard",
    "module": "discussion",
    "moduleLabel": "留言板",
    "title": "留言板",
    "pageType": "crud-list",
    "legacyUrl": "/discuss/discussBoard",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "discuss-discuss-type",
    "path": "/discuss/discussType",
    "module": "discussion",
    "moduleLabel": "留言板",
    "title": "留言類別管理",
    "pageType": "crud-list",
    "legacyUrl": "/discuss/discussType",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "exam-dispatch-exam",
    "path": "/exam/dispatchExam",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "試卷派送",
    "pageType": "complex-form",
    "legacyUrl": "/exam/dispatchExam",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "exam-exam-manage",
    "path": "/exam/exam",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "試卷維護",
    "pageType": "crud-list",
    "legacyUrl": "/exam/exam",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "exam-init-all-question",
    "path": "/exam/initAllQuestion/:questionBankId/:count1/:count2/:count3/:count4/:count5",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "exam-init-all-question",
    "pageType": "complex-form",
    "legacyUrl": "/exam/initAllQuestion/{questionBankId}/{count1}/{count2}/{count3}/{count4}/{count5}",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "exam-question-bank",
    "path": "/exam/questionBankMain",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "題庫管理",
    "pageType": "crud-list",
    "legacyUrl": "/exam/questionBankMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "exam-question-bank-type",
    "path": "/exam/questionBankType",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "exam-question-bank-type",
    "pageType": "crud-list",
    "legacyUrl": "/exam/questionBankType",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "exam-question-manage",
    "path": "/exam/question/:questionBankId",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "exam-question-manage",
    "pageType": "crud-list",
    "legacyUrl": "/exam/question/{questionBankId}",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "exam-testing-manage",
    "path": "/exam/testing",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "線上測驗",
    "pageType": "crud-list",
    "legacyUrl": "/exam/testing",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "exam-view-testing",
    "path": "/exam/exam/prompt/previewTesting",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "exam-view-testing",
    "pageType": "complex-form",
    "legacyUrl": "/exam/exam/prompt/previewTesting",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "exam-view-testing-view-testing",
    "path": "/exam/testing/prompt/viewTesting",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "exam-view-testing-view-testing",
    "pageType": "complex-form",
    "legacyUrl": "/exam/testing/prompt/viewTesting",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "form-all-form-list",
    "path": "/form/queryFormList",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "綜合表單查詢",
    "pageType": "complex-form",
    "legacyUrl": "/form/queryFormList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-class-form-list",
    "path": "/form/classFormList",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "課程表單查詢",
    "pageType": "crud-list",
    "legacyUrl": "/form/classFormList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-co-edit-form-completion-statistics-page",
    "path": "/coEditForm/report/completionStatisticsPage",
    "module": "co-edit-form",
    "moduleLabel": "共同編輯表單專區",
    "title": "共同編輯表單完成度統計",
    "pageType": "complex-form",
    "legacyUrl": "/coEditForm/report/completionStatisticsPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-co-edit-form-export-page",
    "path": "/coEditForm/exportPage",
    "module": "co-edit-form",
    "moduleLabel": "共同編輯表單專區",
    "title": "共同編輯表單匯出",
    "pageType": "complex-form",
    "legacyUrl": "/coEditForm/exportPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-co-edit-form-fill-form",
    "path": "/coEditForm/prompt/form",
    "module": "co-edit-form",
    "moduleLabel": "共同編輯表單專區",
    "title": "form-co-edit-form-fill-form",
    "pageType": "complex-form",
    "legacyUrl": "/coEditForm/prompt/form",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-co-edit-form-form-generator",
    "path": "/coEditForm/formGenerator",
    "module": "co-edit-form",
    "moduleLabel": "共同編輯表單專區",
    "title": "共同編輯表單",
    "pageType": "complex-form",
    "legacyUrl": "/coEditForm/formGenerator",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-co-edit-form-query-page",
    "path": "/coEditForm/queryPage",
    "module": "co-edit-form",
    "moduleLabel": "共同編輯表單專區",
    "title": "共同編輯表單查詢",
    "pageType": "crud-list",
    "legacyUrl": "/coEditForm/queryPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-fill-form",
    "path": "/form/prompt/fillForm",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "form-fill-form",
    "pageType": "complex-form",
    "legacyUrl": "/form/prompt/fillForm",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "form-form-static-list",
    "path": "/form/queryFormStatic",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "表單統計",
    "pageType": "complex-form",
    "legacyUrl": "/form/queryFormStatic",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-plan-form-batch-send",
    "path": "/form/batch/planFormBatchSend",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "批次發送表單",
    "pageType": "complex-form",
    "legacyUrl": "/form/batch/planFormBatchSend",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-plan-form-dispatch",
    "path": "/form/extra/planFormDispatch",
    "module": "instruction-plan",
    "moduleLabel": "訓練計畫專區",
    "title": "訓練計畫手動補發",
    "pageType": "display",
    "legacyUrl": "/form/extra/planFormDispatch",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-plan-form-list",
    "path": "/form/planFormList",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "訓練計畫表單查詢",
    "pageType": "crud-list",
    "legacyUrl": "/form/planFormList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-print-forms",
    "path": "/form/prompt/printForms",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "form-print-forms",
    "pageType": "complex-form",
    "legacyUrl": "/form/prompt/printForms",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "form-template-common-form-template",
    "path": "/formTemplate/commonFormTemplate",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "共用表單設定",
    "pageType": "crud-list",
    "legacyUrl": "/formTemplate/commonFormTemplate",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-template-field-type-list",
    "path": "/formTemplate/fieldType/fieldTypeList",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "常用題型格式維護",
    "pageType": "complex-form",
    "legacyUrl": "/formTemplate/fieldType/fieldTypeList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-template-form-preview",
    "path": "/formTemplate/prompt/formPreview",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "form-template-form-preview",
    "pageType": "complex-form",
    "legacyUrl": "/formTemplate/prompt/formPreview",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "form-template-form-template",
    "path": "/formTemplate/formTemplateList/formTemplate",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "form-template-form-template",
    "pageType": "complex-form",
    "legacyUrl": "/formTemplate/formTemplateList/formTemplate",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-template-form-template-list",
    "path": "/formTemplate/formTemplateList",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "表單設計",
    "pageType": "display",
    "legacyUrl": "/formTemplate/formTemplateList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "form-template-form-template-list-process-form-fields",
    "path": "/formTemplate/processFormFields",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "form-template-form-template-list-process-form-fields",
    "pageType": "display",
    "legacyUrl": "/formTemplate/processFormFields",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "form-template-set-form-fields",
    "path": "/formTemplate/setFormFields",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "form-template-set-form-fields",
    "pageType": "crud-list",
    "legacyUrl": "/formTemplate/setFormFields",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "form-template-set-form-flow",
    "path": "/formTemplate/setFormFlow",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "form-template-set-form-flow",
    "pageType": "complex-form",
    "legacyUrl": "/formTemplate/setFormFlow",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "index",
    "path": "/index",
    "module": "login",
    "moduleLabel": "登入",
    "title": "index",
    "pageType": "login",
    "legacyUrl": "/index",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "redirect",
      "teacher": "redirect",
      "student": "redirect",
      "mentor": "redirect"
    }
  },
  {
    "pageId": "instruction-course-department-code",
    "path": "/instruction/courseDepartmentCode/maintenance",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "課程部門代碼維護",
    "pageType": "crud-list",
    "legacyUrl": "/instruction/courseDepartmentCode/maintenance",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "instruction-plan-target-plan-target-list",
    "path": "/instruction/planTargetList",
    "module": "instruction-plan",
    "moduleLabel": "訓練計畫專區",
    "title": "訓練計畫",
    "pageType": "crud-list",
    "legacyUrl": "/instruction/planTargetList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "instruction-study-item-maintain",
    "path": "/instruction/studyItemMaintain",
    "module": "instruction-plan",
    "moduleLabel": "訓練計畫專區",
    "title": "學習項目內容維護",
    "pageType": "crud-list",
    "legacyUrl": "/instruction/studyItemMaintain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "instruction-study-item-type-maintain",
    "path": "/instruction/studyItemTypeMaintain",
    "module": "instruction-plan",
    "moduleLabel": "訓練計畫專區",
    "title": "學習項目類別維護",
    "pageType": "crud-list",
    "legacyUrl": "/instruction/studyItemTypeMaintain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "instruction-teacher-pool-list",
    "path": "/instruction/teacherPool",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "師資群維護",
    "pageType": "crud-list",
    "legacyUrl": "/instruction/teacherPool",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "leave-leave-annual",
    "path": "/leave/leaveAnnual",
    "module": "leave-form",
    "moduleLabel": "請假專區",
    "title": "學習年度設定作業",
    "pageType": "crud-list",
    "legacyUrl": "/leave/leaveAnnual",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "leave-leave-form",
    "path": "/leave/leaveForm",
    "module": "leave-form",
    "moduleLabel": "請假專區",
    "title": "請假單",
    "pageType": "crud-list",
    "legacyUrl": "/leave/leaveForm",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "leave-leave-holiday",
    "path": "/leave/holiday",
    "module": "leave-form",
    "moduleLabel": "請假專區",
    "title": "工作日維護",
    "pageType": "display",
    "legacyUrl": "/leave/holiday",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "leave-leave-type",
    "path": "/leave/type",
    "module": "leave-form",
    "moduleLabel": "請假專區",
    "title": "請假類別設定",
    "pageType": "crud-list",
    "legacyUrl": "/leave/type",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "main-dentisit-student-main",
    "path": "/main/dentisit/studentMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "學員首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/dentisit/studentMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "forbidden",
      "teacher": "forbidden",
      "student": "reachable",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "main-dentisit-teacher-main",
    "path": "/main/dentisit/teacherMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "教師首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/dentisit/teacherMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "forbidden",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "main-dept-admin-main",
    "path": "/main/departmentAdminMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "科部管理員首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/departmentAdminMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "main-main",
    "path": "/main",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "一般首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "main-medical-affairs-student-main",
    "path": "/main/medicalAffairs/studentMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "學員首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/medicalAffairs/studentMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "forbidden",
      "teacher": "forbidden",
      "student": "reachable",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "main-medical-affairs-teacher-main",
    "path": "/main/medicalAffairs/teacherMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "教師首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/medicalAffairs/teacherMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "forbidden",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "main-new-main-exam-list",
    "path": "/exam/testing/openExamList",
    "module": "exam",
    "moduleLabel": "測驗中心",
    "title": "main-new-main-exam-list",
    "pageType": "crud-list",
    "legacyUrl": "/exam/testing/openExamList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "main-new-main-study-record",
    "path": "/training/studyRecord/openStudyRecordList",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "main-new-main-study-record",
    "pageType": "crud-list",
    "legacyUrl": "/training/studyRecord/openStudyRecordList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "main-student-main",
    "path": "/main/studentMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "學員首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/studentMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "forbidden",
      "teacher": "forbidden",
      "student": "reachable",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "main-teacher-main",
    "path": "/main/teacherMain",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "教師首頁",
    "pageType": "crud-list",
    "legacyUrl": "/main/teacherMain",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "forbidden",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "profile-profile-maintenance",
    "path": "/profile/profileMaintenance",
    "module": "profile",
    "moduleLabel": "個人資料管理",
    "title": "個人基本資料維護",
    "pageType": "crud-list",
    "legacyUrl": "/profile/profileMaintenance",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-common-class-form-export",
    "path": "/report/common/classFormExport",
    "module": "course",
    "moduleLabel": "課程專區",
    "title": "課程表單匯出",
    "pageType": "report",
    "legacyUrl": "/report/common/classFormExport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-common-clazz-attendance-export",
    "path": "/report/common/clazzAttendanceExport",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "課堂出席表現",
    "pageType": "report",
    "legacyUrl": "/report/common/clazzAttendanceExport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-common-clazz-detail-export",
    "path": "/report/common/clazzDetailExport",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "開課明細表",
    "pageType": "report",
    "legacyUrl": "/report/common/clazzDetailExport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-common-plan-form-export",
    "path": "/report/common/planFormExport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "訓練計畫表單匯出",
    "pageType": "report",
    "legacyUrl": "/report/common/planFormExport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-pgywm-all-student-scores",
    "path": "/tsghrpt/pgywm/allStudentScores",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "西醫PGY_學員各訓練階段總成績",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/pgywm/allStudentScores",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-academic-mom",
    "path": "/report/academicMOM/mainPage",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "學術會議紀錄",
    "pageType": "report",
    "legacyUrl": "/report/academicMOM/mainPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-class-form-static",
    "path": "/tsghfunc/toClassForm6",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "課程滿意度調查統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toClassForm6",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-class-form-static-to-class-form-7",
    "path": "/tsghfunc/toClassForm7",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "基本課程滿意度調查統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toClassForm7",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-core-skill-form-report",
    "path": "/tsghrpt/coreSkillFormReport",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "核心技能統計(依技能)",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/coreSkillFormReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-core-skill-report-by-form",
    "path": "/tsghrpt/coreskillreportbyform",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "old核心技能統計(依技能)",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/coreskillreportbyform",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-core-skill-report-by-student",
    "path": "/tsghrpt/coreskillreportbystudent",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "old核心技能統計(依學員)",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/coreskillreportbystudent",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-core-skill-statistic",
    "path": "/tsghrpt/coreSkillStatistic",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "核心技能完成率統計圖表",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/coreSkillStatistic",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-core-skill-statistic-report",
    "path": "/tsghrpt/prompt/coreSkillStatisticReport",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "report-tsgh-core-skill-statistic-report",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/prompt/coreSkillStatisticReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-core-skill-sutdent-report",
    "path": "/tsghrpt/coreSkillSutdentReport",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "核心技能統計(依學員)",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/coreSkillSutdentReport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-gpa-form-report",
    "path": "/tsghrpt/gapFormReport/mainPage",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "等第制表單明細",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/gapFormReport/mainPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "report-tsgh-login-static",
    "path": "/tsghfunc/toLoginLogStaticPage",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "登入使用狀況統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toLoginLogStaticPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-plan-form-static",
    "path": "/tsghfunc/toPlanForm4",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "主治醫師教學滿意度統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toPlanForm4",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-plan-form-static-to-plan-form-5",
    "path": "/tsghfunc/toPlanForm5",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "住院醫師教學滿意度統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toPlanForm5",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-plan-form-static-2",
    "path": "/tsghfunc/toPlanForm8",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "教學門診稽核表統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toPlanForm8",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-plan-form-static-2-to-plan-form-9",
    "path": "/tsghfunc/toPlanForm9",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "教學住診暨床邊教學統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toPlanForm9",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-tsgh-plan-form-static-2-to-plan-form-10",
    "path": "/tsghfunc/toPlanForm10",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "晨會訓練官稽核檢查表統計",
    "pageType": "report",
    "legacyUrl": "/tsghfunc/toPlanForm10",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-ugywm-course-form-finishrate",
    "path": "/tsghrpt/ugywm/courseFormFinishrate",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "課程表單完成率監測",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/ugywm/courseFormFinishrate",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "report-ugywm-student-dept-satisfy",
    "path": "/tsghrpt/ugywm/studentDeptSatisfy",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "西醫UGY_學員對科部整體滿意度問卷統計",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/ugywm/studentDeptSatisfy",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-about",
    "path": "/system/about",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "關於系統",
    "pageType": "display",
    "legacyUrl": "/system/about",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-api-log",
    "path": "/system/apiLog/mainPage",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "Api紀錄",
    "pageType": "display",
    "legacyUrl": "/system/apiLog/mainPage",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "system-changelog",
    "path": "/system/dataChange",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "異動紀錄",
    "pageType": "crud-list",
    "legacyUrl": "/system/dataChange",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-download-log",
    "path": "/system/systemConfig/open/download/log",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "紀錄下載",
    "pageType": "display",
    "legacyUrl": "/system/systemConfig/open/download/log",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-login-log",
    "path": "/system/loginLog",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "登入紀錄",
    "pageType": "display",
    "legacyUrl": "/system/loginLog",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-message-config",
    "path": "/system/messageConfig",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "訊息通知",
    "pageType": "display",
    "legacyUrl": "/system/messageConfig",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-message-config-save-message-config",
    "path": "/system/messageConfig/saveMessageConfig",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "system-message-config-save-message-config",
    "pageType": "display",
    "legacyUrl": "/system/messageConfig/saveMessageConfig",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "system-system-config",
    "path": "/system/systemConfig",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "系統參數",
    "pageType": "display",
    "legacyUrl": "/system/systemConfig",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "system-system-config-save-system-config",
    "path": "/system/systemConfig/saveSystemConfig",
    "module": "system",
    "moduleLabel": "系統管理",
    "title": "system-system-config-save-system-config",
    "pageType": "display",
    "legacyUrl": "/system/systemConfig/saveSystemConfig",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "training-arrange-train",
    "path": "/training/arrange",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "教師安排",
    "pageType": "complex-form",
    "legacyUrl": "/training/arrange",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-education-training",
    "path": "/main/educationTraining",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "training-education-training",
    "pageType": "display",
    "legacyUrl": "/main/educationTraining",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-education-training-student",
    "path": "/main/educationTraining/student",
    "module": "home",
    "moduleLabel": "首頁",
    "title": "training-education-training-student",
    "pageType": "display",
    "legacyUrl": "/main/educationTraining/student",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-permission-manage-student",
    "path": "/training/permmisionManage/student",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "學員管理",
    "pageType": "complex-form",
    "legacyUrl": "/training/permmisionManage/student",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-permission-manage-teacher",
    "path": "/training/permmisionManage/teacher",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "師資管理",
    "pageType": "display",
    "legacyUrl": "/training/permmisionManage/teacher",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-plan-inst-clinical-arrange",
    "path": "/training/planInst/toClinicalArrange",
    "module": "user",
    "moduleLabel": "人員管理",
    "title": "教學團隊",
    "pageType": "display",
    "legacyUrl": "/training/planInst/toClinicalArrange",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-plan-inst-plan-inst-list",
    "path": "/training/planInst/planInstList",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "訓練期程",
    "pageType": "crud-list",
    "legacyUrl": "/training/planInst/planInstList",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-study-passport-study-passport",
    "path": "/training/studyPassport/prompt/downloadPassport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "training-study-passport-study-passport",
    "pageType": "complex-form",
    "legacyUrl": "/training/studyPassport/prompt/downloadPassport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "training-study-passport-study-passport-list",
    "path": "/training/studyPassport",
    "module": "train",
    "moduleLabel": "學員專區",
    "title": "training-study-passport-study-passport-list",
    "pageType": "display",
    "legacyUrl": "/training/studyPassport",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-study-record-show-study-record",
    "path": "/training/studyRecord/showStudyRecordFormN",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "training-study-record-show-study-record",
    "pageType": "complex-form",
    "legacyUrl": "/training/studyRecord/showStudyRecordFormN",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "training-study-record-study-record-fill",
    "path": "/training/studyRecord/fill",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "學習紀錄填寫",
    "pageType": "crud-list",
    "legacyUrl": "/training/studyRecord/fill",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-study-record-study-record-form-content",
    "path": "/training/studyRecord/form/genRecordForm",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "training-study-record-study-record-form-content",
    "pageType": "complex-form",
    "legacyUrl": "/training/studyRecord/form/genRecordForm",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "training-study-record-study-record-form-content-show-study-record-form",
    "path": "/training/studyRecord/form/showStudyRecordForm",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "training-study-record-study-record-form-content-show-study-record-form",
    "pageType": "complex-form",
    "legacyUrl": "/training/studyRecord/form/showStudyRecordForm",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "training-study-record-study-record-status",
    "path": "/training/studyRecord/status",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "學習紀錄查詢",
    "pageType": "crud-list",
    "legacyUrl": "/training/studyRecord/status",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-study-record-study-record-verify",
    "path": "/training/studyRecord/verify",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "training-study-record-study-record-verify",
    "pageType": "display",
    "legacyUrl": "/training/studyRecord/verify",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-transcript-list",
    "path": "/training/transcript",
    "module": "transcript",
    "moduleLabel": "成績單",
    "title": "成績單",
    "pageType": "complex-form",
    "legacyUrl": "/training/transcript",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "vote-dept-manager-recommend",
    "path": "/vote/deptManagerRecommend",
    "module": "vote",
    "moduleLabel": "優良臨床教師投票專區",
    "title": "單位主管推薦",
    "pageType": "crud-list",
    "legacyUrl": "/vote/deptManagerRecommend",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "vote-excellent-teacher",
    "path": "/vote/prompt/voteExcellentTeacher",
    "module": "vote",
    "moduleLabel": "優良臨床教師投票專區",
    "title": "vote-excellent-teacher",
    "pageType": "display",
    "legacyUrl": "/vote/prompt/voteExcellentTeacher",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "vote-total-vote-analysis-report",
    "path": "/tsghrpt/vote/totalVoteAnalysis",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "總可被投票數",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/vote/totalVoteAnalysis",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "vote-total-vote-report",
    "path": "/tsghrpt/vote/totalVote",
    "module": "report",
    "moduleLabel": "報表管理",
    "title": "投票總人數",
    "pageType": "report",
    "legacyUrl": "/tsghrpt/vote/totalVote",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "forbidden",
      "student": "forbidden",
      "mentor": "forbidden"
    }
  },
  {
    "pageId": "vote-vote-maintenance",
    "path": "/vote/main",
    "module": "vote",
    "moduleLabel": "優良臨床教師投票專區",
    "title": "投票維護",
    "pageType": "crud-list",
    "legacyUrl": "/vote/main",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": {
      "admin": "reachable",
      "teacher": "reachable",
      "student": "reachable",
      "mentor": "reachable"
    }
  },
  {
    "pageId": "training-study-record-error-content",
    "path": "/_/training-study-record-error-content",
    "module": "study",
    "moduleLabel": "學習紀錄",
    "title": "training-study-record-error-content",
    "pageType": "unresolved",
    "legacyUrl": null,
    "classification": "未定",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "instruction-personalization-gpa-show-version",
    "path": "/instruction/personalizationGPA/showVersion",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "個人化等第制成績設定",
    "pageType": "unresolved",
    "legacyUrl": "/instruction/personalizationGPA/showVersion",
    "classification": "未定",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "instruction-personalization-gpa-score-setting",
    "path": "/instruction/personalizationGPA/scoreSetting",
    "module": "form-template",
    "moduleLabel": "表單精靈",
    "title": "個人化等第制成績設定",
    "pageType": "display",
    "legacyUrl": "/instruction/personalizationGPA/scoreSetting",
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "error-401",
    "path": "/_/error-401",
    "module": "errors",
    "moduleLabel": "錯誤頁",
    "title": "error-401",
    "pageType": "display",
    "legacyUrl": null,
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "error-403",
    "path": "/_/error-403",
    "module": "errors",
    "moduleLabel": "錯誤頁",
    "title": "error-403",
    "pageType": "display",
    "legacyUrl": null,
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "error-404",
    "path": "/_/error-404",
    "module": "errors",
    "moduleLabel": "錯誤頁",
    "title": "error-404",
    "pageType": "display",
    "legacyUrl": null,
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "error-405",
    "path": "/_/error-405",
    "module": "errors",
    "moduleLabel": "錯誤頁",
    "title": "error-405",
    "pageType": "display",
    "legacyUrl": null,
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "error-500",
    "path": "/_/error-500",
    "module": "errors",
    "moduleLabel": "錯誤頁",
    "title": "error-500",
    "pageType": "display",
    "legacyUrl": null,
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "error-error",
    "path": "/_/error-error",
    "module": "errors",
    "moduleLabel": "錯誤頁",
    "title": "error-error",
    "pageType": "display",
    "legacyUrl": null,
    "classification": "route",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "webcontent-index",
    "path": "/_/webcontent-index",
    "module": "redirects",
    "moduleLabel": "純轉向",
    "title": "webcontent-index",
    "pageType": "redirect",
    "legacyUrl": "/",
    "classification": "redirect-behavior",
    "redirectTarget": "/index",
    "visibleTo": null
  },
  {
    "pageId": "common-html-output",
    "path": "/_/common-html-output",
    "module": "unresolved",
    "moduleLabel": "待決候選清單",
    "title": "common-html-output",
    "pageType": "unresolved",
    "legacyUrl": null,
    "classification": "未定",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "course-clazz-query-list-js",
    "path": "/_/course-clazz-query-list-js",
    "module": "unresolved",
    "moduleLabel": "待決候選清單",
    "title": "course-clazz-query-list-js",
    "pageType": "unresolved",
    "legacyUrl": null,
    "classification": "未定",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "customer-tsgh-draw-board",
    "path": "/_/customer-tsgh-draw-board",
    "module": "unresolved",
    "moduleLabel": "待決候選清單",
    "title": "customer-tsgh-draw-board",
    "pageType": "unresolved",
    "legacyUrl": null,
    "classification": "未定",
    "redirectTarget": null,
    "visibleTo": null
  },
  {
    "pageId": "main-medical-affairs-clinical-main",
    "path": "/_/main-medical-affairs-clinical-main",
    "module": "unresolved",
    "moduleLabel": "待決候選清單",
    "title": "main-medical-affairs-clinical-main",
    "pageType": "unresolved",
    "legacyUrl": null,
    "classification": "未定",
    "redirectTarget": null,
    "visibleTo": null
  }
];
